module.exports = __webpack_public_path__ + "media/images/nav/icon_6-2341b2a9e7cd5fe05c000909826eeac1.svg";